module.exports = __webpack_public_path__ + "static/media/thumbnail_11.0fc7ada3.png";